import { c as _c } from "react/compiler-runtime";
import React, { memo } from 'react';
import AudioPlayerComponent from './audio-player/audio-player.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductAudioTrack } from '@spa/generated/graphql/graphql';
import selectPhononetSettings from '@spa/lib/store/settings/selectors/selectPhononetSettings';
import styles from './track-list.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import { useSelector } from 'react-redux';
interface Props {
  readonly tracks: ReadonlyArray<ProductAudioTrack>;
}
const TrackListComponent: React.FC<Props> = t0 => {
  const $ = _c(8);
  const {
    tracks
  } = t0;
  const {
    audioSamplesUrl
  } = useSelector(selectPhononetSettings);
  const {
    formatMessage
  } = useNamespacedIntl("track-list");
  let t1;
  let t2;
  if ($[0] !== audioSamplesUrl || $[1] !== formatMessage || $[2] !== tracks) {
    const groupedTracks = {};
    for (const track of tracks) {
      const tracksForDisk = groupedTracks[track.diskNumber];
      if (tracksForDisk) {
        tracksForDisk.push(track);
      } else {
        groupedTracks[track.diskNumber] = [track];
      }
    }
    t1 = styles["track-list-component"];
    t2 = Object.keys(groupedTracks).sort(_temp).map(diskNumber => <div key={diskNumber} className={styles["track-list-component__disc"]}><span className={`${styles["track-list-component__disc-number"]} text-lg bold`}>{formatMessage("disk", {
          diskNumber
        })}</span><table><tbody>{groupedTracks[diskNumber].map(t3 => {
            const {
              mainArtist,
              playtime,
              soundFile,
              title,
              trackNumber
            } = t3;
            return <tr key={`${diskNumber}-${trackNumber}`}><td>{trackNumber}</td><td>{soundFile && <AudioPlayerComponent src={`${audioSamplesUrl}/${soundFile}`} />}</td><td>{mainArtist}</td><td>{title}</td>{playtime && <td>{playtime}</td>}</tr>;
          })}</tbody></table></div>);
    $[0] = audioSamplesUrl;
    $[1] = formatMessage;
    $[2] = tracks;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default memo(TrackListComponent);
function _temp(a, b) {
  return Number(a) - Number(b);
}